import { t } from "i18next";

import { fontWeight } from "#app/theme/v1/fontWeights";
import { Flex } from "#shared/view/components/Flex";
import { Image } from "#shared/view/components/Image";
import { Text } from "#shared/view/components/Text";

export const NoQRLDisplay = () => {
  return (
    <Flex direction="column" justify="center" align="center" mt="xl">
      <Image src={"/images/predict.png"} w={180} h={180} mt="lg" />
      <Text fz="lg" mt="md" fw={fontWeight.bold}>
        {t("quoteRequestLines.noQuoteRequestFound")}
      </Text>
    </Flex>
  );
};
